import React from "react";

import {LeadModel} from "@/typings/models/Lead";
import {BranchActionTag} from "@/components/ActionTag";

import styles from "./index.less"
import {F} from "@/utils/intl";

const LeadAppointmentBranch = ({lead, isTable}: {lead: LeadModel, isTable?: boolean}) => {
  const branch = lead?.latest_appointment?.branch_service?.branch
  if (!branch) return <div> - </div>
  const content = (
    <span onClick={(e) => e.stopPropagation()}>
      <BranchActionTag size={'small'} branch={branch} showAddressTooltip />
    </span>
  )

  if (isTable) return content

  return <div>
    <div className={styles.tinyDateKey}><F id={"pages.lead.fields.appointmentBranch"} defaultMessage={"Appointment Branch"}/></div>
    <div>{content}</div>
  </div>

}

export default LeadAppointmentBranch
